import APIService from '@/api'

export default class APIPayment extends APIService{

    constructor(){
        super('payments')
    }

    async getAll(contractId) {
        var response = await this.AxiosInstance
            .get(this.ApiUrl, { params: { contractId: contractId } })
            .catch(error => {
              console.log(error.response)
            });
        return response;
    }

    create(item, contractId) {
        return this.AxiosInstance.post(this.ApiUrl, item, {});
    }

    update(item, contractId) {
        return this.AxiosInstance.put(this.ApiUrl, item, {});
    }

    delete(item) {
        return this.AxiosInstance.delete(this.ApiUrl, { params: { id: item.ID } });
    }
}


// WEBPACK FOOTER //
// ./src/api/payment.js